export enum IAccountType {
    TEST_ADMIN   = 'test-admin',
    TEST_TAKER   = 'test-taker',
    TEST_CTRL    = 'test-ctrl',
    CERT_BODY    = 'test-cert',
}